import { t } from "@/utils/i18n";
import { constant, cal } from "@/utils";
import Icon from "@/components/Icon/Icon";
import styles from "./index.module.less";
import PickTypeLabel from "@/components/PickTypeLabel";
import type { OrderPickType } from "../../types";
import freeShipIcon from "@/assets/img/icon/free-ship.png";

const SHOW_COD_FEE = false;
const {
  order: { PickType },
} = constant;
const { moneyFormat } = cal;

interface IProps {
  shippingOption: OrderPickType;
  currencySymbol: string;
  onClick?: () => void;
}

function ShippingOption(props: IProps) {
  const { currencySymbol } = props;
  const shippingOption = props.shippingOption || {};
  const {
    pickType,
    logisticsName,
    shippingTotal,
    shippingFee,
    codFee,
    shipAddress,
    shippingType,
    crossBorder,
  } = shippingOption;


  // 配送方式点击
  function onShippingOptionClick() {
    props.onClick?.();
  }

  return (
    <div className={styles["shipping-option"]}>
      <div className={styles["shipping-title"]}>{t("物流选项")}</div>
      {!!shippingOption.logisticsId && (
        <div onClick={onShippingOptionClick}>
          <div className={styles["shipping-info"]}>
            <div className={styles["flex-box"]}>
              <PickTypeLabel
                pickType={pickType}
                className={styles["shipping-label"]}
                shippingType={shippingType}
                crossBorder={crossBorder}
              />
              <span className={`${styles["logistics-name"]} ep-2`}>{logisticsName}</span>
            </div>
            {SHOW_COD_FEE &&<div className={styles["money-small"]}>
              <span>{currencySymbol}</span>
              {moneyFormat(shippingTotal || 0)}
            </div>}
          </div>
          <div className={styles["shipping-address"]}>
            {pickType === PickType.SELF_PICK && (
              <div className={styles["flex-box"]}>
                <div className={styles["shipping-bottom-text"]}>
                  {t("地址:")}
                  {shipAddress}
                </div>
                <Icon name="arrow-right" size={26} />
              </div>
            )}

            {pickType !== PickType.SELF_PICK && (
              <div className={styles["flex-box"]}>
                <div className={`${styles["shipping-bottom-text"]} ${styles["flex-box"]}`}>
                  {!!shippingFee && (
                    <span>
                      {t("运输费")} {currencySymbol} {moneyFormat(shippingFee)}
                    </span>
                  )}
                  {SHOW_COD_FEE && !shippingFee && <img src={freeShipIcon} className={styles["free-ship-icon"]} />}
                  {SHOW_COD_FEE && <span>
                    <span className={styles["margin-s"]}>+</span>
                    {t("COD服务费")} {currencySymbol} {moneyFormat(codFee)}
                  </span>}
                </div>
                <Icon name="arrow-right" size={26} />
              </div>
            )}
          </div>
        </div>
      )}

      {!shippingOption.logisticsId && (
        <div onClick={onShippingOptionClick}>
          <div className={styles["flex-box"]}>
            <div className={styles["no-shipping-text"]}>{t("暂无物流，去选择")}</div>
            <Icon name="arrow-right" size={26} />
          </div>
        </div>
      )}
    </div>
  );
}

export default ShippingOption;
